import { messageCreater } from "@domains/utils/messageCreater";
export var list = {
    securities: "securities ban today",
    possibleEntrance: "Possible Entrance",
    possibleExits: "Possible Exits",
    highestOI: "Highest OI",
    highestOIGainer: "Highest OI Gainer",
    highestOILoser: "Highest OI Loser",
    highestVolume: "Highest Volume Growth",
};
export var msgCreater = function (count, section) {
    return messageCreater(count, list[section]);
};
